import {
  Checkbox,
  MenuItem,
  Divider,
  Grid,
  Typography,
  Radio,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Chip,
} from '@mui/material';
import React, { FC } from 'react';
import { AssembleBuild } from '../Model/AzureDevOpsModel';
import { Cancel, CloudUpload } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
} from '../../Common/CommonComponents';
import CustomButton, {
  CustomSelect,
  CustomTextField,
} from '../../../../Common/Components/Controls/InputControls';
import { AssembleFilterType } from '../../ManageFarms/Model/FarmModel';
export function handleCommonCheckbox(
  event: React.ChangeEvent<HTMLInputElement>,
  setState: React.Dispatch<React.SetStateAction<boolean>> | undefined,
) {
  if (setState) setState(event.target.checked);
}

const GetCheckboxStateHandler = (
  e: React.ChangeEvent<HTMLInputElement>,
  commonCheckBox: boolean | undefined,
  setState: React.Dispatch<React.SetStateAction<boolean>> | undefined,
  handleCheckbox?: (event: React.ChangeEvent<HTMLInputElement>) => void,
) => {
  if (commonCheckBox === true) {
    handleCommonCheckbox(e, setState);
  } else if (handleCheckbox) handleCheckbox(e);
};

export const renderCheckbox = (
  name: string,
  checked: boolean,
  label: string,
  handleCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void,
  commonCheckbox?: boolean,
  setState?: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  return (
    <div
      style={{
        display: 'block',
        marginRight: '10px',
      }}
    >
      <Checkbox
        checked={checked}
        color="primary"
        inputProps={{ 'aria-label': 'secondary checkbox' }}
        name={name}
        onChange={(e) => {
          GetCheckboxStateHandler(e, commonCheckbox, setState, handleCheckbox);
        }}
      />
      <label>{label}</label>
    </div>
  );
};

interface RenderTagsProps {
  assemble: AssembleBuild;
}

const RenderTags = (props: RenderTagsProps) => {
  const { assemble } = props;
  return (
    <>
      {assemble.Tags[0] ? (
        <Chip
          color="success"
          label={assemble.Tags[0] ? assemble.Tags[0].toString() : 'No Tag'}
        />
      ) : (
        <Chip color="error" label={'No Tag'} />
      )}
    </>
  );
};

interface BaseDeploymentProps {
  assembleBuild: string;
  handleFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  assemblebuilds: AssembleBuild[];
  selectedassembleBuild: string;
  branches: string[];
  selectedBranch: string;
  setFilterType: (filterType: AssembleFilterType) => void;
  filterType: AssembleFilterType;
  showOnlyTags?: boolean;
  showOnlyBranches?: boolean;
  showOnlyPlatformBranches?: boolean;
  releaseTags?: string[];
  selectedReleaseTag?: string;
}

export const BaseDeployment: FC<BaseDeploymentProps> = ({
  assembleBuild,
  handleFieldChange,
  assemblebuilds,
  selectedassembleBuild,
  branches,
  selectedBranch,
  setFilterType,
  filterType,
  showOnlyTags = false,
  showOnlyBranches = false,
  showOnlyPlatformBranches = false,
  releaseTags = [],
  selectedReleaseTag = '',
}) => {
  // If showOnlyTags is true, render only the release tags dropdown
  if (showOnlyTags) {
    return (
      <CustomSelect
        value={selectedReleaseTag}
        name="SelectedReleaseTag"
        onChange={(e) =>
          handleFieldChange(e as React.ChangeEvent<HTMLInputElement>)
        }
      >
        {(releaseTags ?? []).map((tag) => (
          <MenuItem key={tag} value={tag}>
            <Chip color="success" label={tag} size="small" />
          </MenuItem>
        ))}
      </CustomSelect>
    );
  }

  // If showOnlyPlatformBranches is true, render only the platform branch dropdown
  if (showOnlyPlatformBranches) {
    return (
      <CustomSelect
        value={selectedBranch}
        name="SelectedPlatformBranch"
        onChange={(e) =>
          handleFieldChange(e as React.ChangeEvent<HTMLInputElement>)
        }
      >
        {(branches ?? []).map((branchname) => (
          <MenuItem key={branchname} value={branchname}>
            {branchname.replace('refs/heads/', '')}
          </MenuItem>
        ))}
      </CustomSelect>
    );
  }

  // If showOnlyBranches is true, render only the branch dropdown
  if (showOnlyBranches) {
    return (
      <CustomSelect
        value={selectedBranch}
        name="SelectedBranch"
        onChange={(e) =>
          handleFieldChange(e as React.ChangeEvent<HTMLInputElement>)
        }
      >
        {(branches ?? []).map((branchname) => (
          <MenuItem key={branchname} value={branchname}>
            {branchname.replace('refs/heads/', '')}
          </MenuItem>
        ))}
      </CustomSelect>
    );
  }

  return (
    <CardWrapper>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Build Details
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">Search Build</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            value={assembleBuild}
            placeholder="Search"
            name="AssembleBuild"
            onChange={(e) =>
              handleFieldChange(e as React.ChangeEvent<HTMLInputElement>)
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} alignItems="center" mt={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">Filter</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              onChange={(e) => {
                setFilterType(e.target.value as unknown as AssembleFilterType);
              }}
              value={filterType}
            >
              <FormControlLabel
                value={AssembleFilterType.AssembleName}
                control={<Radio />}
                label="Assemble Name"
              />
              <FormControlLabel
                value={AssembleFilterType.Tag}
                control={<Radio />}
                label="Tag"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      {assemblebuilds && (
        <Grid container spacing={2} alignItems="center" mt={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">Assemble Build</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomSelect
              value={selectedassembleBuild}
              name="SelectedAssemble"
              onChange={(e) =>
                handleFieldChange(e as React.ChangeEvent<HTMLInputElement>)
              }
            >
              {assemblebuilds.map((assemble) => (
                <MenuItem
                  key={assemble.BuildNumber}
                  value={assemble.BuildNumber}
                >
                  {filterType === AssembleFilterType.Tag ? (
                    <RenderTags assemble={assemble} />
                  ) : (
                    assemble.BuildNumber.replace('proarc.assemble_', '')
                  )}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
        </Grid>
      )}

      {branches && (
        <Grid container spacing={2} alignItems="center" mt={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">Platform Branch</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomSelect
              value={selectedBranch}
              name="SelectedBranch"
              onChange={(e) =>
                handleFieldChange(e as React.ChangeEvent<HTMLInputElement>)
              }
            >
              {branches.map((branchname) => (
                <MenuItem key={branchname} value={branchname}>
                  {branchname.replace('refs/heads/', '')}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
        </Grid>
      )}
    </CardWrapper>
  );
};

interface DeploymentTypeProps {
  disasterrecovery: boolean;
  rollback: boolean;
  DeployOnly: boolean;
  handleCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setDeployOnly: React.Dispatch<React.SetStateAction<boolean>>;
  setRollback: React.Dispatch<React.SetStateAction<boolean>>;
  setDisasterrecovery: React.Dispatch<React.SetStateAction<boolean>>;
  displayOptions: {
    deployOnly: boolean;
    rollback: boolean;
    disasterRecovery: boolean;
  };
}

export const DeploymentTypeComponent: FC<DeploymentTypeProps> = ({
  disasterrecovery,
  rollback,
  DeployOnly,
  handleCheckbox,
  setDeployOnly,
  setRollback,
  setDisasterrecovery,
  displayOptions,
}) => {
  const checkboxes = [
    {
      id: 'DeployOnly',
      value: DeployOnly,
      label: 'Deploy Only',
      setter: setDeployOnly,
      disabled: disasterrecovery || rollback,
      display: displayOptions.deployOnly,
    },
    {
      id: 'rollback',
      value: rollback,
      label: 'Roll Back',
      setter: setRollback,
      disabled: disasterrecovery || DeployOnly,
      display: displayOptions.rollback,
    },
    {
      id: 'disasterrecovery',
      value: disasterrecovery,
      label: 'Disaster Recovery',
      setter: setDisasterrecovery,
      disabled: DeployOnly || rollback,
      display: displayOptions.disasterRecovery,
    },
  ];

  return (
    <>
      {checkboxes.map(
        (checkbox) =>
          checkbox.display &&
          !checkbox.disabled &&
          renderCheckbox(
            checkbox.id,
            checkbox.value,
            checkbox.label,
            handleCheckbox,
            true,
            checkbox.setter,
          ),
      )}
    </>
  );
};

interface GlobalDeploymentProps {
  commonresources: boolean;
  webviewer: boolean;
  AZUREFRONTDOOR: boolean;
  formatconverter: boolean;
  indexingsearch: boolean;
  monitoring: boolean;
  handleCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setCommonResources: React.Dispatch<React.SetStateAction<boolean>>;
  setFormatConverter: React.Dispatch<React.SetStateAction<boolean>>;
  setAZUREFRONTDOOR: React.Dispatch<React.SetStateAction<boolean>>;
  setWebViewer: React.Dispatch<React.SetStateAction<boolean>>;
  setIndexingSearch: React.Dispatch<React.SetStateAction<boolean>>;
  setMonitoring: React.Dispatch<React.SetStateAction<boolean>>;
}

export const GlobalDeploymentComponent: FC<GlobalDeploymentProps> = ({
  commonresources,
  webviewer,
  AZUREFRONTDOOR,
  formatconverter,
  indexingsearch,
  monitoring,
  handleCheckbox,
  setCommonResources,
  setFormatConverter,
  setAZUREFRONTDOOR,
  setWebViewer,
  setIndexingSearch,
  setMonitoring,
}) => {
  const checkboxes = [
    {
      id: 'COMMON',
      value: commonresources,
      label: 'Common Resources',
      setter: setCommonResources,
      disabled:
        AZUREFRONTDOOR ||
        webviewer ||
        indexingsearch ||
        formatconverter ||
        monitoring,
    },
    {
      id: 'FORMATCONVERTER',
      value: formatconverter,
      label: 'Format Converter',
      setter: setFormatConverter,
      disabled:
        AZUREFRONTDOOR ||
        webviewer ||
        indexingsearch ||
        commonresources ||
        monitoring,
    },
    {
      id: 'WEBVIEW',
      value: webviewer,
      label: 'Webviewer',
      setter: setWebViewer,
      disabled:
        AZUREFRONTDOOR ||
        formatconverter ||
        indexingsearch ||
        commonresources ||
        monitoring,
    },
    {
      id: 'AZUREFRONTDOOR',
      value: AZUREFRONTDOOR,
      label: 'Azure Front Door',
      setter: setAZUREFRONTDOOR,
      disabled:
        webviewer ||
        formatconverter ||
        indexingsearch ||
        commonresources ||
        monitoring,
    },
    {
      id: 'INDEXINGSEARCH',
      value: indexingsearch,
      label: 'Indexing Search',
      setter: setIndexingSearch,
      disabled:
        webviewer ||
        formatconverter ||
        AZUREFRONTDOOR ||
        commonresources ||
        monitoring,
    },
    {
      id: 'MONITORING',
      value: monitoring,
      label: 'Dashboard and Alerts',
      setter: setMonitoring,
      disabled:
        webviewer ||
        formatconverter ||
        AZUREFRONTDOOR ||
        commonresources ||
        indexingsearch,
    },
  ];

  return (
    <>
      {checkboxes.map(
        (checkbox) =>
          !checkbox.disabled &&
          renderCheckbox(
            checkbox.id,
            checkbox.value,
            checkbox.label,
            handleCheckbox,
            true,
            checkbox.setter,
          ),
      )}
    </>
  );
};

export const DeploymentFooter = (props: {
  DeployAppServices: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  const history = useHistory();
  const handleCancel = () => {
    return history.push('/farm');
  };
  return (
    <>
      <FooterWrapper>
        <FooterContainer>
          <Grid item xs={12} sm="auto">
            <CustomButton
              startIcon={<CloudUpload />}
              onClick={props.DeployAppServices}
              label={'Deploy'}
            />
          </Grid>
          <Grid item xs={12} sm="auto">
            <CustomButton
              startIcon={<Cancel />}
              onClick={handleCancel}
              label={'Cancel'}
            />
          </Grid>
        </FooterContainer>
      </FooterWrapper>
    </>
  );
};
